import React from 'react';
import WidgetIframeProps from './widget-iframe.props';
import Iframe from 'modules/shared/components/iframe';

import './widget-iframe.scss';

const WidgetIframe: React.FC<WidgetIframeProps> = props => {
    if (!props.data?.url) {
        return null;
    }

    return (
        <div className="w-iframe">
            <Iframe src={props.data.url} />
        </div>
    );
};

export default WidgetIframe;
